export default {
  priv: 'pr_device_files',
  overviewTitle: 'Bestanden',
  detailTitle: 'Bestand',
  deleteTitle: 'dit bestand',
  url: '/devices/files',
  apiUrl: '/devicereportfiles/',
  multiSelect: true,
  sortBy: ['file.name'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'devicereportfiles',
  quickFilter: {
    text: 'Zoeken',
    value: 'misc_search',
    type: 'str'
  },
  addRecord: false,
  advancedSearchFields: [
    {
      text: 'Serienummer / Toestel',
      value: 'device_id',
      type: 'optionList',
      optionListName: 'devices'
    },
    {
      text: 'Rapport',
      value: 'devicereport_code',
      type: 'text'
    },
    {
      text: 'Type',
      value: 'file_type_id',
      type: 'optionList',
      optionListName: 'filetypes'
    },
    {
      text: 'Toezichter',
      value: 'supervisor_id',
      type: 'optionList',
      optionListName: 'supervisors'
    },
    {
      text: 'Periode van',
      value: 'date_start',
      type: 'date'
    },
    {
      text: 'Periode tot',
      value: 'date_end',
      type: 'date'
    }
  ],
  tableFields: [
    {
      text: 'Naam',
      value: 'file.name',
      link: '/devices/files/{id}',
      width: '20%'
    },
    {
      text: 'Toestel',
      value: 'device_serial_nr',
      width: '15%'
    },
    {
      text: 'Rapport',
      value: 'devicereport_code',
      link: '/devices/measurereports/{devicereport_id}',
      width: '20%'
    },
    {
      text: 'Type',
      value: 'filetype_name',
      width: '20%'
    },
    {
      text: 'Datum',
      value: 'file.timestamp',
      width: '15%',
      filter: 'date'
    }
  ]
};
